import React from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import _TopLeft from 'src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import { i18nGet } from 'src/tools/tools';

const TopLeft = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const { name } = props;

  //console.log('salesChannels,', salesChannel);

  // const uuid = get(s, 'uuid');
  //  const discountUuid = get(s, 'discountUuid');

  const h = useHistory();
  const goBack = () => {
    h.push(`/settings`);
  };

  const b = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: `/settings`,
      name: getI18n('general.sider.settings'),
    },

    {
      url: ``,
      name: getI18n('thirdPartyAPI.topLeft.thirdPartyAPI'),
    },
    // {
    //   url: ``,
    //   name: name,
    // },
  ];
  return <_TopLeft goBack={goBack} breadcrumbData={b} />;
};
export default TopLeft;
